import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { Section } from "../components/ui";
import RegisterHero from "../components/home/RegisterHero";
import DeviceSummaryCard from "../components/home/DeviceSummaryCard";
import SupportCard from "../components/home/SupportCard";
import GuideGrid from "../components/guides/GuideGrid";
import { GUIDES_INDEX_URL } from "../data/installation-guides";

function Home() {
  return (
    <>
      <RegisterHero />

      <Section eyebrow="Your devices" title="Registered products">
        <DeviceSummaryCard />
      </Section>

      <Section
        eyebrow="Installation guides"
        title="Installing a device?"
        description="Installation instructions are published on artome.fi and kept up to date there."
        action={
          <Link
            href={GUIDES_INDEX_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700, color: "text.primary", whiteSpace: "nowrap" }}
          >
            All guides on artome.fi
          </Link>
        }
      >
        <GuideGrid />
      </Section>

      <Section sx={{ pt: 0 }}>
        <Box>
          <SupportCard />
        </Box>
      </Section>
    </>
  );
}

export default Home;
